import React, { useState } from 'react';
import countries from '../data/CountryData';
import './styles/QuoteForm.css';

const QuoteForm = () => {
  const [movingDate, setMovingDate] = useState('');

  return (
    <form className="quote-form">
      <input type="text" placeholder="Name" className="input-field full-width" />
      <input type="email" placeholder="Email" className="input-field full-width" />
      <input type="tel" placeholder="Phone Number" className="input-field full-width" />
      
      <div className="input-row">
        <select className="input-field half-width" defaultValue="">
          <option value="" disabled>Moving From (Country)</option>
          {countries.map((country) => (
            <option key={country} value={country}>{country}</option>
          ))}
        </select>
        <input type="text" placeholder="City" className="input-field half-width" />
      </div>
      
      <div className="input-row">
        <select className="input-field half-width" defaultValue="">
          <option value="" disabled>Moving To (Country)</option>
          {countries.map((country) => (
            <option key={country} value={country}>{country}</option>
          ))}
        </select>
        <input type="text" placeholder="City" className="input-field half-width" />
      </div>

      <input
        type="date"
        value={movingDate}
        onChange={(e) => setMovingDate(e.target.value)}
        className="input-field full-width"
        placeholder="Moving Date (MM/DD/YYYY)"
        onFocus={(e) => e.target.showPicker?.()} // Chrome-specific enhancement
      />

      <button type="submit" className="submit-btn">Submit</button>
    </form>
  );
};

export default QuoteForm;
